import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { heroSlides } from "@/mocks/heroSlides";

export default function HeroCarousel() {
  const [active, setActive] = useState(0);

  const go = useCallback((dir: number) => {
    setActive((prev) => (prev + dir + heroSlides.length) % heroSlides.length);
  }, []);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setActive((prev) => (prev + 1) % heroSlides.length);
    }, 5500);
    return () => window.clearInterval(timer);
  }, [active]);

  return (
    <section className="relative h-[520px] w-full overflow-hidden md:h-[600px]" aria-label="焦点头条轮播">
      {heroSlides.map((slide, index) => (
        <div
          key={slide.id}
          className={[
            "absolute inset-0 transition-opacity duration-700",
            index === active ? "opacity-100" : "pointer-events-none opacity-0",
          ].join(" ")}
        >
          <img
            src={slide.cover}
            alt={`${slide.title} - 羞羞影视资讯`}
            title={`${slide.title} 影视资讯`}
            className={[
              "h-full w-full object-cover object-top transition-transform duration-[6000ms] ease-out",
              index === active ? "scale-105" : "scale-100",
            ].join(" ")}
          />
        </div>
      ))}

      <div className="absolute inset-0 bg-gradient-to-r from-primary-950/90 via-primary-950/60 to-primary-950/25" />
      <div className="absolute inset-0 bg-gradient-to-t from-primary-950/80 via-transparent to-primary-950/30" />

      <div className="absolute inset-x-0 top-0 z-10 mx-auto w-full max-w-[1280px] px-4 pt-8 md:px-8 md:pt-10">
        <div className="flex items-center gap-3">
          <span className="h-4 w-1 rounded-full bg-accent-500" />
          <h1 className="font-heading text-sm font-bold tracking-[0.35em] text-background-50 md:text-base">
            羞羞影视娱乐
          </h1>
        </div>
      </div>

      <div className="relative mx-auto flex h-full w-full max-w-[1280px] flex-col justify-end px-4 pb-14 md:px-8 md:pb-20">
        {heroSlides.map((slide, index) => (
          <div
            key={slide.id}
            className={[
              "absolute inset-x-4 bottom-14 max-w-2xl transition-all duration-700 md:inset-x-8 md:bottom-20",
              index === active
                ? "translate-y-0 opacity-100"
                : "pointer-events-none translate-y-4 opacity-0",
            ].join(" ")}
          >
            <span className="inline-block rounded-md bg-accent-500 px-3 py-1 text-xs font-semibold text-primary-950">
              {slide.tag}
            </span>
            <h2 className="mt-4 font-heading text-3xl font-black leading-tight text-background-50 md:text-5xl">
              {slide.title}
            </h2>
            <p className="mt-4 max-w-xl text-sm leading-relaxed text-background-100/85 md:text-base">
              {slide.subtitle}
            </p>
            <div className="mt-7 flex flex-wrap items-center gap-3">
              <Link
                to={`/detail/${slide.id}`}
                className="flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-bold text-primary-950 transition-colors hover:bg-accent-400"
              >
                阅读详情
                <i className="ri-arrow-right-line" aria-hidden="true" />
              </Link>
              <Link
                to="/category"
                className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 px-6 py-3 text-sm font-medium text-background-50 backdrop-blur-sm transition-colors hover:bg-background-50/10"
              >
                浏览全部分类
              </Link>
            </div>
          </div>
        ))}

        <div className="relative z-10 mt-auto flex items-center justify-between">
          <div className="flex items-center gap-2">
            {heroSlides.map((slide, index) => (
              <button
                key={slide.id}
                type="button"
                onClick={() => setActive(index)}
                aria-label={`切换到第 ${index + 1} 张焦点图`}
                className={[
                  "h-1.5 rounded-full transition-all",
                  index === active ? "w-8 bg-accent-500" : "w-3 bg-background-50/50 hover:bg-background-50/80",
                ].join(" ")}
              />
            ))}
          </div>
          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={() => go(-1)}
              aria-label="上一张"
              className="flex h-10 w-10 items-center justify-center rounded-full border border-background-50/40 text-background-50 transition-colors hover:bg-background-50/10"
            >
              <i className="ri-arrow-left-s-line text-xl" aria-hidden="true" />
            </button>
            <button
              type="button"
              onClick={() => go(1)}
              aria-label="下一张"
              className="flex h-10 w-10 items-center justify-center rounded-full border border-background-50/40 text-background-50 transition-colors hover:bg-background-50/10"
            >
              <i className="ri-arrow-right-s-line text-xl" aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}